<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        step-indicator(v-bind:activeStep='4')

        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref="generalInformation"
                v-bind:company='company'
                v-model='model'
            )

        .ui.top.attached.header Termin:
        .ui.bottom.attached.segment
            delivery-date-form(
                ref='deliveryDateForm'
                v-model="model"
            )

        wizard-navigation(v-on:back="back()")

</template>

<script>
    import store from '@/store'
    import DeliveryDateForm from '@/components/products/forms/DeliveryDateForm'
    import GeneralInformationForm from '@/components/products/forms/GeneralInformationForm'
    import StepIndicator from '@/components/products/StepIndicator'
    import WizardNavigation from '@/components/products/WizardNavigation'

    //noinspection JSUnusedLocalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            if (store.getters['products/draft'].type === undefined) {
                next({ name: 'products/create' })
            }

            // Unternehmens-ID aus Draft lesen
            const companyId = store.getters['products/draft'].company

            // Unternehmen laden
            await store.dispatch('companies/loadOne', { id: companyId })

            // Navigation fortsetzen
            next()
        },

        created() {
            this.$scrollTo('body')
        },

        components: { DeliveryDateForm, GeneralInformationForm, StepIndicator, WizardNavigation },

        computed: {
            company() {
                return store.getters['companies/byId'](this.model.company)
            },
            isInvalid() {
                return this.$refs.generalInformation.$v.$invalid ||
                    this.$refs.deliveryDateForm.$v.$invalid
            },
            model: {
                get() { return this.$store.getters['products/draft'] || {} },
                set(model) { this.$store.commit('products/REPLACE_DRAFT', { draft: model }) }
            },
        },

        methods: {

            back() {
                this.$router.push({
                    name: 'products/create/step3',
                    params: this.$route.params
                })
            },

            submit() {
                // Embedded-Forms als "submitted" markieren
                this.$refs.generalInformation.$v.$touch()
                this.$refs.deliveryDateForm.$v.$touch()

                // Pruefen ob alle Formular valide sind
                if (this.isInvalid) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Auf zu Step 5!
                this.$router.push({
                    name: 'products/create/step5',
                    params: this.$route.params
                })
            }

        }

    }

</script>
